import Block from './Block'

export default class CTabs extends Block {
    
    constructor(blockRoot) {
        super(blockRoot)
        if (this.root.data('ctabs-status') !== 'enable') {
            return
        }
        var navLinks = this.root.find('.ctabs__nav__item')
        var contentTabs = this.root.find('.ctabs__content__item')
        
        
        this.sections = navLinks.toArray().map(link => {
            let id = link.dataset.ctabId
            
            $(link).on('click', event => {
                event.preventDefault()
                this.showSectionByID(id)
            })
            
            return {
                id: id,
                navNode: link,
                sectionNode: contentTabs.filter((j, section) => section.dataset.ctabId === id).get(0),
            }
        })
        
        this.showSectionByID(this.sections[0].id)
    }
    
    _getSection(section) {
        var prev = [],
            curr = false,
            next = []
        this.sections.map(sect => {
            if (sect.id === section.id) {
                curr = sect
            } else if (curr) {
                next.push(sect)
            } else if (!curr) {
                prev.push(sect)
            }
        })
        return {
            prev: prev,
            curr: curr || this.sections[0],
            next: next,
        }
    }
    
    showSection(section) {
        if (this.blocked) {
            return this
        }
        this.blocked = true
        
        var sections = this._getSection(section)
        sections.prev.map(section => this.hideAsPrev(section))
        sections.next.map(section => this.hideAsNext(section))
        $(sections.curr.navNode).removeClass('inactive').addClass('active')
        $(sections.curr.sectionNode)
            .addClass('visible').addClass('current-tab')
            .removeClass('hidden').removeClass('next-tab').removeClass('prev-tab')
        
        setTimeout(() => {
            this.blocked = false
        }, this.transitionDuration)
        
        return this
    }
    
    hideAsPrev(section) {
        $(section.navNode).addClass('inactive').removeClass('active')
        $(section.sectionNode)
            .addClass('hidden').addClass('prev-tab')
            .removeClass('visible').removeClass('current-tab').removeClass('next-tab')
        return this
    }
    
    hideAsNext(section) {
        $(section.navNode).addClass('inactive').removeClass('active')
        $(section.sectionNode)
            .addClass('hidden').addClass('next-tab')
            .removeClass('visible').removeClass('current-tab').removeClass('prev-tab')
        return this
    }
    
    showSectionByID(sectionid) {
        this.sections.map(sect => {
            if (sect.id === sectionid) {
                this.showSection(sect);
            }
        });
        
        return this;
    }
}
